interface AssistantBadgeProps {
  initials: string;
  displayName: string;
  isPending: boolean;
}

export const AssistantBadge: React.FC<AssistantBadgeProps> = ({
  initials,
  displayName,
  isPending,
}) => {
  return (
    <div
      className="md-timeline-template-event-badge"
      title={`Assistant: ${displayName}${isPending ? ' (Pending Approval)' : ''}`}
      style={{
        top: '19px',
        left: '0px',
        borderColor: 'rgba(125, 0, 150, 1)',
        background: '#fff',
        color: 'rgba(125, 0, 150, 1)',
      }}
    >
      <span>{initials}</span>
    </div>
  );
};
